// extracted by mini-css-extract-plugin
export var infoRow = "_sf-2";
export var labelContainer = "_sf-0";
export var rightInfo = "_sf-1";